<template>
  <div v-if="actualEmpreendimento">
      <InternaTopo
      :folder="actualEmpreendimento.folder_image"
      :video="actualEmpreendimento.video"
      :background="actualEmpreendimento.background_image"
      :image="actualEmpreendimento.title_image"
      >
      </InternaTopo>
      <!-- Inserir a slug do empreendimento abaixo -->
      <InternaItens :title="actualEmpreendimento.title" :slug="actualEmpreendimento.slug" :menus="actualEmpreendimento.menus" :status="actualEmpreendimento.for_sale"></InternaItens>
      <router-view></router-view>
      <CtaConheca :business="actualEmpreendimento"></CtaConheca>
  </div>
</template>
<script>
import InternaTopo from './InternaTopo'
import InternaItens from './InternaItens'
import CtaConheca from './../CtaConheca'
import { mapGetters } from 'vuex'
export default {
  components: {
    InternaItens,
    InternaTopo,
    CtaConheca
  },
  computed: {
    ...mapGetters([
      'actualEmpreendimento'
    ])
  },
  created () {
    this.$store.dispatch('showEmpreendimento', this.$route.params.slug).then(response => {
      document.title = 'Comcasa | ' + response.data.title
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/Interna.vue